export class Ledger {
  id: number;
  created_at: any;
  created_at_str: string;
  chart_of_account_id: number;
  chart_of_account_name: string;
  category: string;
  amount: number;
  description: string;
  editing: boolean = false;
}
